import { isDevMode } from '@angular/core';
import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import * as fromApp from '@store/reducers/app.reducer';
import * as fromAuth from '@store/reducers/auth.reducer';
import * as fromFeedback from '@store/reducers/feedback.reducer';
import * as fromAdministrator from '@store/reducers/administrator.reducer';
import * as fromRestaurantManager from '@store/reducers/restaurant-manager.reducer';

export interface State {

  [fromApp.appFeatureKey]: fromApp.State;

  [fromAuth.authFeatureKey]: fromAuth.State;

  [fromFeedback.feedbackFeatureKey]: fromFeedback.State;

  [fromAdministrator.administratorFeatureKey]: fromAdministrator.State;

[fromRestaurantManager.restaurantManagerFeatureKey]: fromRestaurantManager.State;


}

export const reducers: ActionReducerMap<State> = {

  [fromApp.appFeatureKey]: fromApp.reducer,

  [fromAuth.authFeatureKey]: fromAuth.reducer,

  [fromFeedback.feedbackFeatureKey]: fromFeedback.reducer,

  [fromAdministrator.administratorFeatureKey]: fromAdministrator.reducer,

  [fromRestaurantManager.restaurantManagerFeatureKey]: fromRestaurantManager.reducer,
};


export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
